import { createTheme } from "@mui/material";
import { COLORS } from "./constants";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0, // Extra small screens
      sm: 600, // Small screens
      md: 1000, // Medium screens (customized)
      lg: 1240, // Large screens
      xl: 1920, // Extra large screens
    },
  },
  typography: {
    fontFamily: "TisaSansPro",
    h1: {
      fontFamily: "TisaSansPro-Medium",
    },
    h2: {
      fontFamily: "TisaSansPro-Medium",
    },
    h3: {
      marginTop: "12px",
      fontFamily: "TisaSansPro-Medium",
    },
    // Toolbar title
    h6: {
      fontFamily: "TisaPro-Bold",
      fontSize: "36px",
    },
    subtitle1: {
      fontFamily: "TisaSansPro-Medium",
      fontSize: "16px",
      paddingLeft: "16px !important",
    },
    body1: {
      fontSize: "16px",
    },
  },
  palette: {
    primary: {
      main: COLORS.DIDACTO_BLUE,
      contrastText: COLORS.DIDACTO_WHITE,
      dark: COLORS.DIDACTO_DARK_BLUE,
    },
    secondary: {
      main: COLORS.DIDACTO_RED,
      dark: COLORS.DIDACTO_DARK_RED,
      contrastText: COLORS.DIDACTO_WHITE,
    },
    error: {
      main: "#cc0000",
    },
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: "2.2rem",
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          minWidth: "auto",
          marginBottom: "40px",
          "& tfoot": {
            "& div": {
              fontSize: "14px",
            },
            "& tr > td": {
              paddingLeft: 0,
              paddingRight: 0,
            },
            "& p": {
              fontSize: "14px",
            },
            "& .MuiTablePagination-selectLabel + div": {
              display: "flex",
              alignItems: "center",
              "& > svg": {
                top: "2px",
                right: 0,
              },
            },
            "& .MuiTablePagination-actions": {},
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& button": {
            fontSize: "16px",
            fontFamily: "TisaSansPro-Bold",
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "& > th": {
            zIndex: 0,
            fontSize: "16px",
            fontFamily: "TisaSansPro-Bold",
            "& button > div": {
              display: "flex",
              alignItems: "center",
            },
          },
          "& td": {
            fontSize: "16px",
            cursor: "pointer",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          "& span": {
            position: "unset",
          },
        },
      },
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          "& tr": {
            height: "68.5px",
          },
          "& .MuiToolbar-root": {
            marginTop: "16px !important",
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          "& p": {
            fontSize: "14px",
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "14px",
          backgroundColor: COLORS.DIDACTO_BLUE,
        },
        arrow: {
          color: COLORS.DIDACTO_BLUE,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: "2Opx",
          fontFamily: "TisaSansPro-Medium",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "1.2rem", // default size
          // only when it's an error
          "&.Mui-error": {
            fontSize: "1.2rem",
          },
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {},
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          fontFamily: "TisaSansPro-Medium",
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          padding: "0px !important",
          "& .MuiButtonBase-root:hover .MuiSvgIcon-root": {
            color: `${COLORS.DIDACTO_DARK_BLUE} !important`,
          },
          "& .MuiSvgIcon-root": {
            width: "24px",
            height: "24px",
          },
          position: "unset",
        },
      },
    },
  },
});
export { theme };
